import React, { useState, useEffect } from "react";
import { setPageTitle } from "../../../utils/document";
import DashboardLayout from "../../../components/layout/DashboardLayout";
import SyncStatus from "./components/SyncStatus";

const ADMIN_TABS = [
  { id: "sync-status", label: "Sync Status" },
];

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState("sync-status");

  useEffect(() => {
    setPageTitle("Admin Dashboard");
  }, []);

  return (
    <DashboardLayout
      tabs={ADMIN_TABS}
      activeTab={activeTab}
      onTabChange={setActiveTab}
    >
      {activeTab === "sync-status" && <SyncStatus />}
    </DashboardLayout>
  );
};

export default AdminDashboard;
